import { Flex } from "@chakra-ui/react";

import { NormalActivityTab } from "./NormalActivityTab";
import { ShieldedTransactionsAccordion } from "./ShieldedTransactionsAccordion";

export const Activity = () => (
  <Flex zIndex={1} flexDirection="column" flexGrow={1}>
    <ShieldedTransactionsAccordion />

    <NormalActivityTab />
  </Flex>
);
